var version = "10.3.5";

export { version as v };
//# sourceMappingURL=package-c5574446.js.map
